// Utility for managing form-specific assets

export interface FormAssets {
  headerDesktop: string;
  headerMobile: string;
}

export const getFormAssetPath = (formId: string, fileName: string): string =>
  `/forms/${formId}/${fileName}`;

export const getFormAssets = (formId: string): FormAssets => {
  return {
    headerDesktop: getFormAssetPath(formId, 'header.png'),
    headerMobile: getFormAssetPath(formId, 'header-mobile.png'),
  };
};

// Available form IDs
export const FORM_IDS = {
  M365_COPILOT_STARTER_KIT: 'm365copilotstarterkit',
  IKP3M: 'ikp3m',
  M365_SECURITY_WEBINAR: 'm365securitywebinar',
  SHAREGATE_ANFRAGE: 'sharegateanfrage',
  WORLD_BACKUP_DAY_2026: 'worldbackupday2026',
  KI_WIRD_MITARBEITER: 'kiwirdmitarbeiter',
  EU_AI_ACT_ZERTIFIKAT: 'euaiact-zertifikat',
  M365_IM_BLINDFLUG: 'm365imblindflug',
  AGENT_PULSE: 'agentpulse',
} as const;

export type FormId = typeof FORM_IDS[keyof typeof FORM_IDS];